import { initSentry, createLogger } from '@repo/observability'

const environment = import.meta.env.MODE as 'development' | 'staging' | 'production'

// Initialize Sentry for error tracking
export function initObservability() {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (dsn) {
    initSentry({
      dsn,
      environment,
      tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    })
  }
}

// Create app logger
export const logger = createLogger('web', {
  level: environment === 'production' ? 'info' : 'debug',
})
